export default {
  solutions: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbCurrent: 'الحلول',
    hero: {
      eyebrow: 'الحلول',
      title: 'الحل المناسب لكل مبنى',
      lead: 'سواء كان منزلًا خاصًا أو مساحة تجارية أو مستودعًا – نجد معًا نظام الكاميرات الأمثل لمتطلباتك.',
    },
    grid: {
      eyebrow: 'حلول المباني في لمحة',
      title: 'ستة مجالات – وعد واحد: أمان حقيقي',
      lead: 'تقود كل بطاقة إلى عرض مخصص مع نقاط المراقبة النموذجية والحلول التقنية المناسبة.',
    },
    tag: { privat: 'خاص', gewerbe: 'شركات', innen: 'داخلي', außen: 'خارجي', neu: 'جديد', erweiterung: 'توسعة' },
    more: 'اعرف المزيد',
    cta: {
      title: 'غير متأكد من الحل المناسب؟',
      lead: 'نحلل مبنىك معًا ونوصيك بالمزيج المناسب من الكاميرات والتسجيل والملحقات.',
      primary: 'احصل على استشارة دون التزام',
      secondary: 'ابدأ مخطط الكاميرات',
    },
  },
};